import { useEffect, useRef } from 'react';
import Nav from './components/Nav';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Contact from './components/Contact';
import './App.css';

function CustomCursor() {
  const dotRef = useRef(null);
  const ringRef = useRef(null);

  useEffect(() => {
    let mouseX = 0, mouseY = 0;
    let ringX = 0, ringY = 0;
    let raf;

    const onMove = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
      }
    };

    const lerp = (a, b, t) => a + (b - a) * t;

    const animate = () => {
      ringX = lerp(ringX, mouseX, 0.12);
      ringY = lerp(ringY, mouseY, 0.12);
      if (ringRef.current) {
        ringRef.current.style.transform = `translate(${ringX}px, ${ringY}px) translate(-50%, -50%)`;
      }
      raf = requestAnimationFrame(animate);
    };

    const onEnter = () => ringRef.current?.classList.add('hover');
    const onLeave = () => ringRef.current?.classList.remove('hover');

    document.addEventListener('mousemove', onMove);
    document.querySelectorAll('a, button, .nav-link, .hero-tag, .tech-pill, .stat, .project-card').forEach(el => {
      el.addEventListener('mouseenter', onEnter);
      el.addEventListener('mouseleave', onLeave);
    });

    raf = requestAnimationFrame(animate);
    return () => {
      document.removeEventListener('mousemove', onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <>
      <div className="cursor-dot" ref={dotRef} />
      <div className="cursor-ring" ref={ringRef} />
    </>
  );
}

export default function App() {
  return (
    <div className="app">
      <CustomCursor />
      <div className="grid-bg" />
      <div className="scanlines" />
      <div className="noise" />

      {/* Ambient glow orbs */}
      <div className="glow-orb" style={{
        width: 600, height: 600,
        background: 'rgba(0,255,163,0.04)',
        top: '10%', left: '-15%'
      }} />
      <div className="glow-orb" style={{
        width: 400, height: 400,
        background: 'rgba(124,211,252,0.04)',
        top: '40%', right: '-10%'
      }} />
      <div className="glow-orb" style={{
        width: 500, height: 500,
        background: 'rgba(244,114,182,0.03)',
        bottom: '10%', left: '20%'
      }} />

      <Nav />
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Contact />
    </div>
  );
}
